@if (isInitialized) {
  <oe-chart [title]="('GENERAL.GRID' | translate)  + '&nbsp;-&nbsp;' + ('EDGE.HISTORY.EXTERNAL_LIMITATION' | translate)"
    [showPhases]="showPhases" [showTotal]="showTotal" (setShowTotal)="setShowTotal($event)"
    (setShowPhases)="setShowPhases($event)" [period]="service.historyPeriod.value">
    <pickdate custom-pickdate [historyPeriods]="['day', 'week']"></pickdate>
    <common-grid-details-external-limitation-chart [isOnlyChart]="true"></common-grid-details-external-limitation-chart>
    <oe-footer-subnavigation [backButton]="true"></oe-footer-subnavigation>
  </oe-chart>
}
